import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    if (!email || !password) {
      setError("Please enter email and password.");
      return false;
    }
    return true;
  };

  const handleLogin = async (e) => {
    console.log(email, password);
    if (!validateForm()) return;
   
     try {
      setLoading(true);

      const response = await axiosInstance.post("/auth/login", {
        username: email,
        password: password
      });

      // If backend returns no user
      if (!response.data || !response.data.token) {
        setError("No user details found.");
        return;
      }

      // Store token
      
      sessionStorage.setItem("token", response.data.token);
      sessionStorage.setItem("userName", response.data.user);
      sessionStorage.setItem("role", response.data.role);
      //sessionStorage.setItem("userData", response.data.userdata);
      sessionStorage.setItem("userData", JSON.stringify(response.data.userdata));
      await fetchCatalogs();
      navigate("/dashboard");

    } catch (err) {

      if (err.response?.status === 401) {
        setError("Invalid email or password.");
      } else if (err.response?.status === 404) {
        setError("User not found.");
      } else {
        setError("Something went wrong. Please try again.");
      }

    } finally {
      setLoading(false);
    }
    
  };

   const fetchCatalogs = async () => {
    try {
      setLoading(true);
       const response = await axiosInstance.get("/catalogs");
       const allCatalogs = response.data;
        sessionStorage.setItem("cacheCatalogs", JSON.stringify(response.data));
       //setCatalogs(response.data);
       // find active year
        const activeYear = allCatalogs?allCatalogs.find(c => c.catalogName === "AcademicYear"):{};

        if (activeYear) {
          //setSelectedYear(activeYear.id);
          sessionStorage.setItem("academicYearId", activeYear.id);
          //activeYear.entries.length > 0? setYears(activeYear.entries): setYears([]);
          //sessionStorage.setItem("academicYearId", activeYear.id);
        }
    } catch (err) {
      //alert("Failed to load Academic Years,Please retry");
      console.error(err);
       console.error("Failed to load CacheCatalogs");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen bg-blue-700 md:bg-gray-100">
      {loading && <Loader />}
       {/* LEFT SIDE */}
        <div className="flex items-center gap-4 px-10 py-5">
            {loading && <Loader />}
          {/* Hamburger only mobile */}
          {/* <button onClick={toggleSidebar} className="md:hidden">
            <FaUserCircle  size={30} />
          </button> */}
  
          {/* Logo */}
          <img
            src="/Avyb_Web_Logo.png"
            alt="School Logo"
            className="h-10 md:h-12 w-auto rounded hidden md:block"
          />
  
          {/* School Name */}
          <h1 className="hidden md:block text-lg font-semibold">
            AVYB Technologies
          </h1>
        </div>


      {/* ===== MAIN SECTION ===== */}
      <div className="flex items-center justify-center px-10 py-20">

        {/* LEFT SIDE - COMPANY INFO */}
        <div className="w-1/2 pr-16 hidden lg:block">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            AVYB Educational Management System
          </h2>

          <p className="text-gray-600 leading-relaxed text-lg">
            AVYB is a modern cloud-based management platform
            designed to simplify academic operations, attendance tracking,
            finance management, examinations, and communication between
            teachers, students, and parents.
          </p>

          <ul className="mt-6 space-y-3 text-gray-600">
            <li>✔ Role-based Dashboards</li>
            <li>✔ Attendance & Reports</li>
            <li>✔ Fee & Finance Management</li>
            <li>✔ Examination & Results</li>
            <li>✔ Communication System</li>
          </ul>
        </div>


        {/* RIGHT SIDE - LOGIN CARD */}
        <div className="bg-white shadow-2xl rounded-2xl p-10 w-full max-w-md">

          <h3 className="text-2xl font-semibold text-blue-800 mb-6 text-center">
            Login To Account
          </h3>

          <div className="space-y-5">

            <div>
              <label className="block text-gray-600 mb-1">
                 UserName
              </label>
              <input
                type="email"
                placeholder="Enter UserName"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label className="block text-gray-600 mb-1">
                Password
              </label>
              <input
                type="password"
                placeholder="Enter your password"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
              {error && (
                <div className="text-red-600 text-sm">
                  {error}
                </div>
              )}
            {/* Forgot Password Link */}
            <div className="text-right mt-2">
            <a
                href="/forgot-password"
                className="text-sm text-blue-600 hover:underline"
            >
                Forgot Password?
            </a>
            </div>
            <button
              onClick={handleLogin}
              className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition text-lg"
            >
              {loading ? "Logging in..." : "Login"}
            </button>

          </div>

          <p className="text-center text-gray-500 mt-6 text-sm">
            © 2026 AVYB Technologies. All rights reserved.
          </p>

        </div>

      </div>

    </div>
  );
}